export const GENDER_OPTIONS = [
  {
    value: "male",
    description: "Male",
  },
  {
    value: "female",
    description: "Female",
  },
  {
    value: "other",
    description: "Other",
  },
];

export const MARITAL_STATUS_OPTIONS = [
  {
    value: "single",
    description: "Single",
  },
  {
    value: "married",
    description: "Married",
  },
  {
    value: "divorced",
    description: "Divorced",
  },
  {
    value: "widowed",
    description: "Widowed",
  },
];
